// Image optimization utilities for better performance

// TODO: Implement when needed for WebP conversion and CDN optimization
// export const getOptimizedImageSrc = (src: string, width: number, height: number): string => {
//   // For now, return the original src
//   // In production, you could implement:
//   // - WebP conversion
//   // - Multiple sizes for responsive images
//   // - CDN optimization
//   return src
// }

export const preloadCriticalImages = (imageUrls: string[]): void => {
  imageUrls.forEach((url) => {
    const link = document.createElement('link')
    link.rel = 'preload'
    link.as = 'image'
    link.href = url
    document.head.appendChild(link)
  })
}

export const lazyLoadBackgroundImages = (): void => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const element = entry.target as HTMLElement
        const backgroundImage = element.dataset.backgroundImage
        if (backgroundImage) {
          element.style.backgroundImage = `url(${backgroundImage})`
          element.removeAttribute('data-background-image')
          observer.unobserve(element)
        }
      }
    })
  })

  document.querySelectorAll('[data-background-image]').forEach((el) => {
    observer.observe(el)
  })
}

// TODO: Implement when needed for dynamic image sizing
// export const optimizeImageDimensions = (originalWidth: number, originalHeight: number, maxWidth: number, maxHeight: number) => {
//   const aspectRatio = originalWidth / originalHeight
//
//   if (originalWidth <= maxWidth && originalHeight <= maxHeight) {
//     return { width: originalWidth, height: originalHeight }
//   }
//
//   if (aspectRatio > maxWidth / maxHeight) {
//     return { width: maxWidth, height: Math.round(maxWidth / aspectRatio) }
//   } else {
//     return { width: Math.round(maxHeight * aspectRatio), height: maxHeight }
//   }
// }
